import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
//Services
import { LoaderService } from "src/app/services/loader/loader.service";
import { RouterService } from "src/app/services/router/router.service";
import { AuthService } from "src/app/services/auth/auth.service";
import { UserService } from "src/app/services/user/user.service";
import { ModalController, Platform } from "@ionic/angular";
import { NotificationService } from "src/app/services/notifications/notification.service";
import { UtilService } from "src/app/services/common/utils.service";
import { LanguagesService } from "src/app/services/languagesService/languages.service";
import { AlertService } from "src/app/services/alert/alert.service";
import { RemoteConfigService } from "src/app/services/remote-config/remote-config.service";
import { TagsService } from "src/app/services/tags/tags.service";
import { ChangePasswordPage } from "../change-password/change-password.page";
import { EmblueService } from 'src/app/services/emblue/emblue.service';
import { FcmService } from 'src/app/services/fcm/fcm.service';
import { first } from 'rxjs/operators';

@Component({
  selector: "app-profile-config",
  templateUrl: "./profile-config.page.html",
  styleUrls: ["./profile-config.page.scss"],
})
export class ProfileConfigPage implements OnInit {
  channelSms: boolean;
  channelEmail: boolean;
  channelPush: boolean;
  disabledSms: boolean;
  disabledEmail: boolean;
  disabledPush: boolean;
  userForm: FormGroup;
  LOADER_ID = "profile-detail";
  authEmailIsActivated: boolean;
  constructor(
    private formBuilder: FormBuilder,
    private loaderService: LoaderService,
    public authService: AuthService,
    public userService: UserService,
    public routerService: RouterService,
    private notiServices: NotificationService,
    private util: UtilService,
    public languageService: LanguagesService,
    public alertService: AlertService,
    public remoteconfig: RemoteConfigService,
    private tagsService: TagsService,
    public modalController: ModalController,
    private emblueService: EmblueService,
    private fcmService: FcmService
  ) {
    this.userForm = this.formBuilder.group({
      document: ["", Validators.required],
      name: ["", Validators.required],
      lastName: [""],
      email: [""],
      phone: [""],
      dateBorn: ["", Validators.required],
    });
  }

  ngOnInit() {
    this.initialize();
    this.fillForm();
  }

  async initialize() {
    this.tagsService.setEventTag(
      "profile_config_page",
      "profile_config_screen_viewed"
    );
    this.authEmailIsActivated = await this.remoteconfig.authEmailIsActivated();
    await this.util.showLoading(this.languageService.textsIU.loader_message.charging);
    (await this.notiServices.getChannelUser()).subscribe(
      async (response: any) => {
        await this.util.closeLoading(null);
        this.channelSms = response.channels.sms.accept;
        this.channelEmail = response.channels.email.accept;
        this.channelPush = response.channels.push.accept;
        this.channelCheckAll();
      },
      async (err) => {
        await this.util.closeLoading(null);
      }
    );
  }

  async sendForm() {
    await this.loaderService.presentLoading(this.LOADER_ID);
    const { document, name, lastName, dateBorn } = this.userForm.value;
    try {
      const data = {
        docNumber: document,
        name: name,
        lastnames: lastName,
        dateBorn,
      };
      await this.userService.saveUserExtraInfo(data);
      await this.loaderService.cancelLoader(this.LOADER_ID);
    } catch (err) {
      await this.loaderService.cancelLoader(this.LOADER_ID);
    }
  }

  async fillForm() {
    const data: any = {};
    //  this.loaderService.presentLoading(this.LOADER_ID);
    try {
      const userFirebase = await this.authService.getUSerInfoFromFirebase();
      this.userService.getUserInfo().subscribe(
        (basicUserInfo: any) => {
          data.email = userFirebase.email;
          data.phone = userFirebase.phoneNumber || "";
          data.name = basicUserInfo.name;
          data.document = basicUserInfo.docNumber;
          data.lastName = basicUserInfo.lastnames;
          data.dateBorn = basicUserInfo.dateBorn;
          this.userForm.patchValue(data);
          this.loaderService.cancelLoader(this.LOADER_ID);
        },
        async (err) => {
          console.log(err);
          await this.loaderService.cancelLoader(this.LOADER_ID);
        }
      );
    } catch (err) {
      console.log(err);
      this.loaderService.cancelLoader(this.LOADER_ID);
    }
    this.loaderService.cancelLoader(this.LOADER_ID);
  }

  async changeEmail() {
    this.routerService.redirect("change-email");
  }
  async changePhone() {
    // this.routerService.redirect("app/profile/profile-detail/change-phone");
  }
  async changePassword() {
    this.routerService.redirect("app/change-password", ChangePasswordPage, null, "gnx-modal-radius gnx-modal-xs");
  }

  async channelCheck(event: any, channel: string) {
    switch (channel) {
      case "sms":
        this.channelCheckSms(event.target.checked);
        break;
      case "email":
        this.channelCheckEmail(event.target.checked);
        break;
      case "push":
        this.channelCheckPush(event.target.checked);
        break;
      default:
        console.log("no se selecciono channel");
        break;
    }
  }

  channelCheckAll() {
    if (!this.channelEmail && !this.channelPush) {
      this.minimumOneChannel(this.channelSms);
      this.disabledSms = true;
    } else if (!this.channelSms && !this.channelPush) {
      this.minimumOneChannel(this.channelEmail);
      this.disabledEmail = true;
    } else if (!this.channelSms && !this.channelEmail) {
      this.minimumOneChannel(this.channelPush);
      this.disabledPush = true;
    }
  }
  channelCheckSms(checked: boolean) {
    if (!this.channelEmail && this.channelPush) {
      this.minimumOneChannel(checked);
      this.disabledPush = true;
    } else if (this.channelEmail && !this.channelPush) {
      this.minimumOneChannel(checked);
      this.disabledEmail = true;
    }
    if (checked) {
      this.disabledPush = false;
      this.disabledEmail = false;
    }
    this.channelSms = checked;
  }

  channelCheckEmail(checked: boolean) {
    if (!this.channelSms && this.channelPush) {
      this.minimumOneChannel(checked);

      this.disabledPush = true;
    } else if (this.channelSms && !this.channelPush) {
      this.minimumOneChannel(checked);

      this.disabledSms = true;
    }
    if (checked) {
      this.disabledPush = false;
      this.disabledSms = false;
    }
    this.channelEmail = checked;
  }

  channelCheckPush(checked: boolean) {
    if (!this.channelSms && this.channelEmail) {
      this.minimumOneChannel(checked);

      this.disabledEmail = true;
    } else if (this.channelSms && !this.channelEmail) {
      this.minimumOneChannel(checked);

      this.disabledSms = true;
    }
    if (checked) {
      this.disabledSms = false;
      this.disabledEmail = false;
    }
    this.channelPush = checked;
  }
  minimumOneChannel(checked: any) {
    if (!checked) {
      this.alertService.presentAlert(this.languageService.textsIU.loader_message.notification_message);
    }
  }
  async sendNoti() {
    const data: any = {
      sms: this.channelSms,
      email: this.channelEmail,
      push: this.channelPush,
    };
    
    await this.util.showLoading(this.languageService.textsIU.loader_message.sending);
    //comunication preferences updated on Emblue provider
    try {
      this.fcmService.getUserInfoUser().pipe(first()).subscribe((user: any) => {
        if (user) {
          this.emblueService.getToken().then(async (token: any) => {
            let user_email = (user.email) ? user.email : 'mobile_' + user.phone.trim() + '@nomail.com';
            let editCustomFields = "sms_preference:|:" + this.channelSms + ":|:1|||email_preference:|:" + this.channelEmail + ":|:1|||push_preference:|:" + this.channelPush + ":|:1";
            this.emblueService.setNewContact(user_email, editCustomFields, token).then(result => {

            });
          });
        }
      });
    } catch (error) {
      console.log("ERROR On Emblue integration process", error);
    }
    (await this.notiServices.acceptChannels(data)).subscribe(
      async () => {
        await this.util.closeLoading(null);
      },
      async () => {
        await this.util.closeLoading(
          this.languageService.textsIU.loader_message.error_send
        );
      }
    );
  }

  DeleteAccount(){
    console.log("delete Account");
    this.routerService.navigate("app/delete-account-term")
  }
  get getTextIUPageProfileConfig() {
    return this.languageService.textsIU.page_profile_config;
  }
}
